import { db, auth } from './firebase';
import { doc, updateDoc, arrayUnion, arrayRemove, getDoc, Timestamp } from 'firebase/firestore';

export const followUser = async (followerId: string, targetId: string) => {
  console.log('🔄 followUser - Début:', { followerId, targetId });
  
  // Vérifier l'état de l'authentification
  const currentUser = auth.currentUser;
  if (!currentUser) {
    console.error('❌ Aucun utilisateur authentifié');
    throw new Error('Utilisateur non authentifié');
  }
  
  console.log('🔍 Utilisateur authentifié:', {
    uid: currentUser.uid,
    isFollowerMatch: currentUser.uid === followerId
  });
  
  try {
    const followerRef = doc(db, 'users', followerId);
    const targetRef = doc(db, 'users', targetId);
    
    // Vérifier que les documents existent
    console.log('🔍 Vérification existence des documents...');
    const followerDoc = await getDoc(followerRef);
    const targetDoc = await getDoc(targetRef);
    
    if (!followerDoc.exists()) {
      console.error('❌ Document follower n\'existe pas:', followerId);
      throw new Error(`Document utilisateur ${followerId} n'existe pas`);
    }
    
    if (!targetDoc.exists()) {
      console.error('❌ Document target n\'existe pas:', targetId);
      throw new Error(`Document utilisateur ${targetId} n'existe pas`);
    }
    
    console.log('✅ Documents existent. Follower data:', followerDoc.data());
    console.log('✅ Documents existent. Target data:', targetDoc.data());
    
    console.log('📝 Mise à jour following pour:', followerId);
    console.log('📍 Document path:', followerRef.path);
    
    try {
      await updateDoc(followerRef, { 
        following: arrayUnion(targetId),
        updatedAt: Timestamp.now()
      });
      console.log('✅ Mise à jour following réussie');
    } catch (error) {
      console.error('❌ Erreur mise à jour following:', error);
      throw error;
    }
    
    console.log('📝 Mise à jour followers pour:', targetId);
    console.log('📍 Document path:', targetRef.path);
    
    try {
      await updateDoc(targetRef, { 
        followers: arrayUnion(followerId),
        updatedAt: Timestamp.now()
      });
      console.log('✅ Mise à jour followers réussie');
    } catch (error) {
      console.error('❌ Erreur mise à jour followers:', error);
      throw error;
    }
    
    console.log('✅ followUser - Succès');
  } catch (error) {
    console.error('❌ followUser - Erreur:', error);
    throw error;
  }
};

export const unfollowUser = async (followerId: string, targetId: string) => {
  console.log('🔄 unfollowUser - Début:', { followerId, targetId });
  
  // Vérifier l'état de l'authentification
  const currentUser = auth.currentUser;
  if (!currentUser) {
    console.error('❌ Aucun utilisateur authentifié');
    throw new Error('Utilisateur non authentifié');
  }
  
  console.log('🔍 Utilisateur authentifié:', {
    uid: currentUser.uid,
    isFollowerMatch: currentUser.uid === followerId
  });
  
  try {
    const followerRef = doc(db, 'users', followerId);
    const targetRef = doc(db, 'users', targetId);
    
    // Vérifier que les documents existent
    console.log('🔍 Vérification existence des documents...');
    const followerDoc = await getDoc(followerRef);
    const targetDoc = await getDoc(targetRef);
    
    if (!followerDoc.exists()) {
      console.error('❌ Document follower n\'existe pas:', followerId);
      throw new Error(`Document utilisateur ${followerId} n'existe pas`);
    }
    
    if (!targetDoc.exists()) {
      console.error('❌ Document target n\'existe pas:', targetId);
      throw new Error(`Document utilisateur ${targetId} n'existe pas`);
    }
    
    console.log('✅ Documents existent. Follower data:', followerDoc.data());
    console.log('✅ Documents existent. Target data:', targetDoc.data());
    
    console.log('📝 Suppression following pour:', followerId);
    try {
      await updateDoc(followerRef, { 
        following: arrayRemove(targetId),
        updatedAt: Timestamp.now()
      });
      console.log('✅ Suppression following réussie');
    } catch (error) {
      console.error('❌ Erreur suppression following:', error);
      throw error;
    }
    
    console.log('📝 Suppression followers pour:', targetId);
    try {
      await updateDoc(targetRef, { 
        followers: arrayRemove(followerId),
        updatedAt: Timestamp.now()
      });
      console.log('✅ Suppression followers réussie');
    } catch (error) {
      console.error('❌ Erreur suppression followers:', error);
      throw error;
    }
    
    console.log('✅ unfollowUser - Succès');
  } catch (error) {
    console.error('❌ unfollowUser - Erreur:', error);
    throw error;
  }
};

export const getFollowers = async (userId: string): Promise<string[]> => {
  const userSnap = await getDoc(doc(db, 'users', userId));
  return userSnap.exists() ? userSnap.data().followers || [] : [];
};

export const getFollowing = async (userId: string): Promise<string[]> => {
  const userSnap = await getDoc(doc(db, 'users', userId));
  return userSnap.exists() ? userSnap.data().following || [] : [];
};
